// @ts-nocheck - TODO: Fix complex union types and Redux state access
/* eslint-disable no-unused-vars */
import { Transition } from '@headlessui/react';
import { Fragment, useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import {
	BsBoxArrowRight as BoxArrowRight,
	BsDashCircle as DashCircle,
	BsGear as Gear,
	BsHeart as Heart,
	BsPlusCircle as PlusCircle,
	BsQuestionCircle as QuestionCircle,
	BsShieldCheck as ShieldCheck,
} from 'react-icons/bs';
import { NumericFormat } from 'react-number-format';
import { useSelector, useDispatch } from 'react-redux';

import BayAvatar from '../../BayAvatar';
import BaySwitch from '../../BaySwitch';
import BayTooltip from '../../BayTooltip';
import DollarIcon from '../../Icons/DollarIcon';
import logOffRequest from './logOff';
import type { TranslationFunction } from '../../types/common';

interface SocialNetwork {
	name: string;
	icon: string;
	id?: string;
	page_url?: string;
}

interface User {
	ActingAsPUBLICID?: string;
	PUBLICID?: string;
	ActingAsIMAGEPATH?: string;
	ActingAsFIRSTNAME?: string;
	ActingAsLASTNAME?: string;
	ActingAsEMAIL?: string;
	ActingAsActorAccount?: boolean;
	parent_account_id?: string;
	ActingAsBAY_PARENT_ACCOUNT_ID?: string;
	showActAsButton?: boolean;
	showPlan?: boolean;
	isEnterprise?: boolean;
	agent_charges_to_parent_account?: boolean;
	totalCredits?: number;
	totalMarketingCredits?: number;
	totalAccountCredits?: number;
	membershipPlan?: string;
	customizePlan?: boolean;
	subscription_plan_code?: string;
	aws_smc_base_url?: string;
	fb_id?: string;
	instagram_page_id?: string;
	instagram_username?: string;
	twitter_id?: string;
	twitter_screen_name?: string;
	linkedin_id?: string;
	linkedin_url?: string;
	linkedin_business_id?: string;
	linkedin_business_url?: string;
	youtube_channel_id?: string;
	tiktok_name?: string;
	tiktok_profile_link?: string;
	hideYoutube?: boolean;
}

interface MyAccountSocialProps {
	user?: User;
	openModalFunc?: () => void;
	t?: TranslationFunction;
	updateLaunchpadApi?: any;
	selectLaunchpadSettingsData?: any;
	showLaunchpadButton?: boolean;
	showLaunchpadUpgradeButton?: boolean;
}

const MyAccountSocial = ({
	user,
	t,
	updateLaunchpadApi,
	selectLaunchpadSettingsData,
	showLaunchpadButton = false,
	showLaunchpadUpgradeButton = false,
}: MyAccountSocialProps) => {
	const dispatch = useDispatch();
	const launchpadSettingsData = useSelector(selectLaunchpadSettingsData);

	const [showBreakDown, setShowBreakDown] = useState(false);
	const [socialNetworks, setSocialNetworks] = useState<SocialNetwork[]>([]);
	const [showLaunchpadOnLogin, setShowLaunchpadOnLogin] = useState(false);

	const imageUrl = user?.ActingAsIMAGEPATH
		? user?.ActingAsIMAGEPATH
		: 'https://bay-office-staging.com/global/images/nophoto/nophoto-agents-thumb.jpg';

	useEffect(() => {
		functionGetSocialNetworks(user);
		// Set the launchpad toggle state from the settings data - default to true if no setting exists
		setShowLaunchpadOnLogin(
			launchpadSettingsData?.launchpadSettings?.navigationSettings
				?.showLaunchpadOnLogin ?? true,
		);
	}, [user, launchpadSettingsData]);

	const functionGetSocialNetworks = (user) => {
		if (!user) {
			return;
		}
		let social_networks = [
			{
				name: 'Facebook',
				icon: '/facebook-icon.png',
				id: user.fb_id,
				page_url: `https://www.facebook.com/${user.fb_id}`,
			},
			{
				name: 'Instagram',
				icon: '/instagram-icon.png',
				id: user.instagram_page_id,
				page_url: `https://www.instagram.com/${user.instagram_username}`,
			},
			{
				name: 'Twitter',
				icon: '/twitter-logo-gray.png',
				id: user.twitter_id,
				page_url: `https://www.twitter.com/${user.twitter_screen_name}`,
			},
			{
				name: 'LinkedIn',
				icon: '/linkedin-icon.png',
				id: user.linkedin_id,
				page_url: `${user.linkedin_url}`,
			},
			{
				name: 'LinkedIn Business',
				icon: '/linkedin_business-icon.png',
				id: user.linkedin_business_id,
				page_url: `${user.linkedin_business_url}`,
			},
			{
				name: 'YouTube',
				icon: '/youtube-icon.svg',
				id: user.youtube_channel_id,
				page_url: `https://www.youtube.com/channel/${user.youtube_channel_id}`,
			},
			{
				name: 'tiktok',
				icon: '/tiktok-icon.png',
				id: user.tiktok_name,
				page_url: user.tiktok_profile_link,
			},
		];

		if (user.hideYoutube) {
			social_networks = social_networks.filter((e) => e.name !== 'YouTube');
		}

		setSocialNetworks(social_networks);
	};

	const authSocial = (networkName) => {
		let newLocation = '';
		const network = networkName.toLowerCase();

		switch (network) {
		case 'facebook':
			newLocation = '/facebook-connect';
			break;
		case 'twitter':
			newLocation = '/social-media/reconnect?network=twitter';
			break;
		case 'linkedin':
			newLocation = '/social-media/reconnect?network=linkedin';
			break;
		case 'linkedin business':
			newLocation = '/social-media/connect?network=linkedin_business';
			break;
		case 'instagram':
			newLocation = '/social-media/connect?network=instagram';
			break;
		case 'youtube':
			newLocation = '/social-media/connect?network=youtube';
			break;
		case 'tiktok':
			newLocation = '/social-media/connect?network=tiktok';
			break;

		default:
			break;
		}

		return (window.location.href = newLocation);
	};

	const CreditsBreakdown = () => {
		return (
			<div className="breakdown column-direction border-0 max-w-100" id="totalCredit">
				<div className="row pb-3 ad-credits">
					<div className="col">
						<div className="icon" />
						<div className="total">
							$
							<span className="total-account-coupons">
								{user.totalMarketingCredits}
							</span>
						</div>
					</div>
					<div className="col">
						<div className="title-desc fw-medium">Marketing Credits</div>
						<div className="text-desc">
							Valid for Ads and Print Orders. Excludes Smart Campaigns and Google Ads.
						</div>
					</div>
				</div>
				<div className="row pb-3 account-credits">
					<div className="col">
						<div className="icon" />
						<div className="total">
							$
							<span className="total-account-credits">
								{user.totalAccountCredits}
							</span>
						</div>
					</div>
					<div className="col">
						<div className="title-desc fw-medium">Account Credits</div>
						<div className="text-desc">
							General-purpose credits that apply to any purchase or your next subscription bill.
						</div>
					</div>
				</div>
			</div>
		);
	};

	// eslint-disable-next-line no-unused-vars
	const handleLaunchpadToggle = async (checked) => {
		setShowLaunchpadOnLogin(checked);

		let kvstoreId;
		// Determine the kvstore ID
		if (user?.parent_account_id && user?.parent_account_id !== '') {
			kvstoreId = user?.parent_account_id;
		} else if (
			user?.ActingAsBAY_PARENT_ACCOUNT_ID &&
			user?.ActingAsBAY_PARENT_ACCOUNT_ID !== ''
		) {
			kvstoreId = user?.ActingAsBAY_PARENT_ACCOUNT_ID;
		} else {
			kvstoreId = user?.PUBLICID;
		}

		// Update the settings in kvstore
		const updatedSettings = {
			...launchpadSettingsData,
			launchpadSettings: {
				...(launchpadSettingsData?.launchpadSettings || {}),
				navigationSettings: {
					...(launchpadSettingsData?.launchpadSettings?.navigationSettings ||
						{}),
					showLaunchpadOnLogin: checked,
				},
			},
		};

		try {
			await dispatch(
				updateLaunchpadApi({
					component: 'launchpadSettings',
					realm: 'BAY',
					userId: kvstoreId,
					isCompanyContext: true,
					data: updatedSettings,
				}),
			);
		} catch (error) {
			console.error('Error updating launchpad settings:', error);
			// Revert the local state if the API call fails
			setShowLaunchpadOnLogin(!checked);
		}
	};

	return user ? (
		<>
			<div
				className="user-menu-header cursor-pointer"
				onClick={() => (window.location.href = '/settings/profile')}
			>
				<BayAvatar
					first={user?.ActingAsFIRSTNAME}
					imgUrl={imageUrl}
					last={user?.ActingAsLASTNAME}
					size="md"
				/>
				<div className="user-menu-details cursor-pointer">
					<div className="user-menu-details-name">{user.ActingAsFIRSTNAME}</div>
					<div className="user-menu-details-email">{user.ActingAsEMAIL}</div>
					<div className="user-menu-details-profile-link">View Profile</div>
				</div>
			</div>
			{/* Legacy in-drawer "Act As" / "Stop Acting As" removed. Act As now
			    lives in the top-nav button (see MyAccountButton), and Stop
			    Acting As in the ActAsBanner shown while acting as another user. */}
			{/* <!--- Plan ---> */}
			{user.showPlan && !user.agent_charges_to_parent_account && !['bronze', 'custom'].includes(user.subscription_plan_code?.split('_')?.[0]) && (
				<div className="user-menu-item ps-3">
					<div className="d-flex w-100 flex-wrap">
						<div className="drawer-section ">Membership Plan</div>
						<Col xs={6}>
							<span className="text-capitalize">{user.membershipPlan} </span>
							Plan
						</Col>
						<Col className="text-right pe-3" xs={6}>
							<a
								href={user.customizePlan ? '/settings/ads' : '/settings/plans'}
							>
								Customize
							</a>
						</Col>
					</div>
				</div>
			)}
			{/* <!--- Credits ---> */}
			{(user.isEnterprise || !user.agent_charges_to_parent_account) && (
				<div className="user-menu-item ps-3">
					<div className="d-flex w-100 flex-wrap">
						<div className="drawer-section ">Available Credits</div>
						<Col className="my-2">
							<div className="d-flex align-items-center">
								<Col className="pe-0" xs="auto">
									<span className="credits-badge-inner">
										<DollarIcon />
									</span>
								</Col>
								<Col className="ps-0">
									<span className="coupon-and-credit-total">
										<NumericFormat
											fixedDecimalScale
											decimalScale={2}
											displayType="text"
											prefix="$"
											thousandSeparator
											value={user?.totalCredits}
										/>
									</span>
								</Col>
							</div>
						</Col>
						<Col className="my-2 pe-3">
							<a
								className="toggle-hide-js toggle-hide justify-content-end"
								onClick={() => setShowBreakDown(!showBreakDown)}
							>
								See Breakdown{' '}
								<span className="icon-small text-pink">
									{showBreakDown ? <DashCircle /> : <PlusCircle />}
								</span>
							</a>
						</Col>
						<Transition
							as={Fragment}
							enter="transition-opacity duration-75"
							enterFrom="opacity-0"
							enterTo="opacity-1"
							leave="transition-opacity duration-150"
							leaveFrom="opacity-1"
							leaveTo="opacity-0"
							show={showBreakDown}
						>
							<div>
								<CreditsBreakdown />
							</div>
						</Transition>
					</div>
				</div>
			)}
			{/* <!--- Social ---> */}
			<div className="user-menu-item ps-3">
				{/* w-100: this is a flex item of .user-menu-item, so without it it
				    shrink-wraps and the rows never reach the drawer's right edge. */}
				<div className="social-connections w-100">
					<div className="drawer-section ">Social Networks</div>

					{socialNetworks.map((item, i) => {
						return (
							<div key={i} className="row social-network-link me-0">
								{/* col-auto, not col-1: col-1 is a percentage, so it would widen
								    with the now-full-width row and push the status text right.
								    me-4 (21px) replaces the legacy 25px margin to absorb most of
								    the width the icons gained in myaccount.scss. */}
								<div className="col-auto pe-0 me-4 social-icon">
									<img
										alt={item.name}
										src={`${user?.aws_smc_base_url}${item.icon}`}
									/>
								</div>
								<div className="col-auto connect-status">
									<div
										className={`connected-status ${
											item.id ? '' : 'not-connected-status'
										}`}
									>
										{item.id ? 'Connected' : 'Not Connected'}{' '}
										{item?.name === 'LinkedIn Business'
											? '(Business)'
											: item?.name.includes('LinkedIn') && '(Personal)'}
									</div>
								</div>
								<div className="col text-end pe-3 me-0 linkage-status">
									{item.id ? (
										<a href={item.page_url} target="_blank" rel="noreferrer">
											Visit
										</a>
									) : (
										<BayTooltip
											motion="zoom"
											overlay={
												<div id="connectNetworkMobile" style={{ width: 280 }}>
													<div>
														It doesn't look like you're connected to
														<span className="network-name"> {item.name} </span>.
														Would you like to connect now?
													</div>
													<div className="btn-connect-row">
														<span className="auth-choice">
															<div
																className="btn btn-row btn-success btn-success-row"
																onClick={() => authSocial(item.name)}
															>
																Yes
															</div>
														</span>
													</div>
												</div>
											}
											overlayStyle={{ pointerEvents: 'auto' }}
											placement="topRight"
											trigger="click"
										>
											<span className="not-connected-js text-pink">
												Connect
											</span>
										</BayTooltip>
									)}
								</div>
							</div>
						);
					})}
				</div>
			</div>
			{/* Temporarily hidden - launchpad login setting
			{!(!showLaunchpadButton || showLaunchpadUpgradeButton) && (
				<div className='d-flex flex-column gap-3 border-bottom ps-3 p-2'>
					<div className='d-flex flex-row align-items-center'>
						<span className="fw-semibold fs-6 text-dark mt-1">{t ? t('displayLaunchpadUponNextLogin') : 'Display Launchpad Upon Next Login'}</span>
						<BayTooltip
							overlay={t ? t('displayLaunchpadUponNextLoginDesc2') : 'When enabled, the Launchpad will automatically appear when you log in.'}
							placement="top"
						>
							<QuestionCircle className="ms-2 cursor-pointer" fill="var(--bs-gray-700)" />
						</BayTooltip>
					</div>
					<BaySwitch
						label="Show"
						id="show-launchpad-social"
						name="show-launchpad-social"
						checked={showLaunchpadOnLogin}
						onChange={handleLaunchpadToggle}
					/>
				</div>
			)}
			*/}
			<div className="user-menu-item logout-button">
				<div
					className="inner"
					onClick={() => logOffRequest('social')}
				>
					<BoxArrowRight />
					Logout
				</div>
			</div>
		</>
	) : (
		<div className="user-menu-item">No User Data</div>
	);
};

export default MyAccountSocial;
